import * as FileSaver from 'file-saver';
import * as Papa from 'papaparse';

const CSV_EXTENSION = '.csv';

export function exportAsCsvFile(data, csvFileName: string): void {
  if (data.length > 0) {
    // Convert JSON to CSV format
    const csv = Papa.unparse(data);

    // Convert CSV string to Blob
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

    // Generate filename with timestamp
    const fileName = `${csvFileName}_export_${new Date().toLocaleString(
      'en-GB',
      {
        timeZone: 'Asia/Kolkata',
        hour12: true,
      }
    )}${CSV_EXTENSION}`;

    // Save file
    FileSaver.saveAs(blob, fileName);
  } else {
    console.warn('No Data Found');
  }
}
